{
  "fr": {
    "dashboard": {
      "greetings": {
        "afternoon": "Bon après-midi {first_name}",
        "evening": "Bonsoir {first_name}",
        "morning": "Bonjour {first_name}",
        "night": "Bonne nuit {first_name}"
      },
      "titles": {
        "activityFeed": "Activités",
        "assignedTasks": "Mes Tâches",
        "newsFeed": "Fil d'Actualité",
        "ongoingTickets": "En Cours",
        "openTickets": "Ouvert",
        "tickets": "Conversations",
        "totalTickets": "Toutes",
        "unreadTickets": "Non Lu",
        "yourAssignedTickets": "Vos conversations assignées"
      }
    }
  }
}
